import React from "react";
import { Quote, Star } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/effects/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";
import { ASSETS } from "@/data/assets";

export const Testimonials = () => {
  const { t } = useLanguage();
  const items = t.testimonials.items.map((it, i) => ({ ...it, avatar: ASSETS.avatars[i] }));

  return (
    <section className="relative overflow-hidden py-24 sm:py-32">
      <div className="absolute left-1/4 top-0 h-96 w-96 rounded-full bg-accent/10 blur-[150px]" />
      <div className="relative mx-auto max-w-6xl px-6">
        <SectionHeading tag={t.testimonials.tag} title={t.testimonials.title} subtitle={t.testimonials.subtitle} />

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {items.map((item, i) => (
            <Reveal key={item.name} delay={(i % 2) * 0.08}>
              <div className="glass flex h-full flex-col rounded-3xl p-7 shadow-card sm:p-8">
                <div className="flex items-center justify-between">
                  <Quote className="h-9 w-9 text-primary/40" />
                  <div className="flex gap-0.5">
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Star key={s} className="h-4 w-4 fill-primary text-primary" />
                    ))}
                  </div>
                </div>
                <p className="mt-5 flex-1 text-base leading-relaxed text-foreground/90">
                  “{item.quote}”
                </p>
                <div className="mt-6 flex items-center gap-4 border-t border-border/50 pt-5">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="h-14 w-14 rounded-full border border-primary/30 object-cover"
                  />
                  <div className="leading-tight">
                    <p className="font-semibold text-foreground">{item.name}</p>
                    <p className="text-sm text-muted-foreground">{item.role}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
